import { HTTPClient } from '@abaco/web-common/src/HTTP';
import { PagedResults, PagingParams } from '@abaco/web-common/src/Paging';
import { ActivityEquipmentIn, Equipment, EquipmentFuelInfo, EquipmentFuelInfoOut, EquipmentIn, EquipmentOut, EquipmentSettings, IotService } from '../models/Equipment';

export default class EquipmentApi {

    private http: HTTPClient;
    private rootPath: string;

    constructor(http: HTTPClient, rootPath: string) {
        this.http = http;
        this.rootPath = rootPath;
    }

    public async getAllEquipments(pkCuaa: number) {
        let equipments: Equipment[] = [];
        let totalCount = 0;
        do {
            const res = await this.getEquipments(pkCuaa, {count: 300, offset: equipments.length}, null);
            equipments = equipments.concat(res.records);
            totalCount = res.totalcount;
        } while (equipments.length < totalCount);
        return equipments;
    }

    public async getEquipments(pk_cuaa: number, paging: PagingParams, filter: string | null): Promise<PagedResults<Equipment>>{
        const res = await this.http.get(`${this.rootPath}/v1/equipments/subjects/${pk_cuaa}/equipments`, {
            params: {
                offset: paging.offset,
                count: paging.count,
                filter: filter ? `^description like ${filter.toUpperCase()}` : undefined
            }
        })

        return res.data;
    }

    public async getEquipmentById(pk_cuaa: number, id: number): Promise<any>{
        const res = await this.http.get(`${this.rootPath}/v1/equipments/subjects/${pk_cuaa}/equipments`, {
            params: {
                filter:`equipment_id eq ${id}`
            }
        })

        return res;
    }

    public async addActionEquipment(pk_cuaa: number, campaign: number, execution_id: number, newEquipment: EquipmentOut): Promise<EquipmentIn> {
        const res = await this.http.post(`${this.rootPath}/v1/plots/subjects/${pk_cuaa}/${campaign}/actions/${execution_id}/equipments`, newEquipment);
        return res.data;
    }

    public async deleteActionEquipment(pk_cuaa: number, campaign: number, execution_id: number, execution_resource_id: number): Promise<EquipmentIn> {
        const res = await this.http.delete(`${this.rootPath}/v1/plots/subjects/${pk_cuaa}/${campaign}/actions/${execution_id}/equipments/${execution_resource_id}`);
        return res.data;
    }

    public async addActivityEquipment(pk_cuaa: number, campaign: number, action_id: number, newEquipment: EquipmentOut): Promise<ActivityEquipmentIn> {
        const res = await this.http.post(`${this.rootPath}/v1/plots/subjects/${pk_cuaa}/${campaign}/activities/${action_id}/equipments`, newEquipment);
        return res.data;
    }

    public async deleteActivityEquipment(pk_cuaa: number, campaign: number, action_id: number, execution_resource_id: number): Promise<ActivityEquipmentIn> {
        const res = await this.http.delete(`${this.rootPath}/v1/plots/subjects/${pk_cuaa}/${campaign}/activities/${action_id}/equipments/${execution_resource_id}`);
        return res.data;
    }


    public async getEquipmentFuelInfo(pk_cuaa: number, equipment_id: number, detailOut: EquipmentFuelInfoOut): Promise<EquipmentFuelInfo[]> {
        const res = await this.http.post(`${this.rootPath}/v1/equipments/subjects/${pk_cuaa}/equipments/${equipment_id}/estimate_fuel_consumption`, detailOut);
        return res.data;
    }


    public async getEquipmentServices(pkCuaa: number, equipmentId: number): Promise<IotService[]>{
        const res = await this.http.get(`${this.rootPath}/v1/equipments/subjects/${pkCuaa}/equipments/${equipmentId}/dictionary_services?filters=pkid ne`, {
            params: {
                offset: 0,
                count: 300,
            }
        })
        return res.data;
    }

    public async canManageEquipmentVolume(pkCuaa: number) {
        const res = await this.http.get(
            `/sitiagri-rest-api/api_basic/v1/user_registry/module_competencies/BEST_PRACTICE/ACT_EQUIPMENT_VOLUME`,
            {
                params: {
                    subject_id: pkCuaa
                }
            }
        );

        return res.data.result;
    }

    public async getEquipmentSettings(pkCuaa: number): Promise<EquipmentSettings> {
        const res = await this.http.get(`/sitiagri-rest-api/api_basic/v1/equipments/subjects/${pkCuaa}/settings`);
        return res.data;
    }

}
